import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import variableStyles from '../../styles/variables.module.css.js';

const Variant18PathwayIllustration = /*#__PURE__*/ forwardRef(({ color = variableStyles.black }, ref)=>jsx("svg", {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1704 1922",
        children: jsx("path", {
            ref: ref,
            d: "M131.114 1775.57c138.146-38.35 291.368-31.1 413.328-115.78 92.598-64.25 140.841-186.69 93.857-294.3-49.453-113.43-184.685-181.2-207.369-302.85-18.716-100.593 54.249-202.159 148.448-242.197 94.198-40.038 202.789-29.488 300.972-.724 98.183 28.763 190.68 74.615 288.28 105.352 90.34 28.421 192.71 42.592 276.54-1.507 81.08-42.597 128.87-134.694 133.38-226.225 4.46-91.513-29.51-181.528-79.3-258.438-73.28-113.262-176.99-218.93-281.86-302.859",
            stroke: color,
            strokeWidth: 220,
            strokeMiterlimit: 10,
            strokeLinecap: "round"
        })
    }));

export { Variant18PathwayIllustration as default };
